import Head from 'next/head';
import ElectronicCommunicationsDisclosure from 'src/views/Marketing/Legal/ElectronicComms';

export default function Example() {
  return (
    <>
      <Head>
        <title>Electronic Communications Disclosure & Consent | OneShop</title>
        <meta
          name='description'
          content='OneShop helps sellers sell on marketplaces such as Poshmark. Try for free, no credit card required.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/legal/electronic-communications' />
        <meta property='og:url' content='https://tools.oneshop.com/legal/electronic-communications' />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
      </Head>
      <ElectronicCommunicationsDisclosure />
    </>
  );
}
